<template>
  <div class="actionsInRow">
    <v-tooltip top v-if="!hideView && permissions.customers.actions.view">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" small class="mr-2" @click.native="$emit('view', customer)">
          <v-icon>mdi-eye-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.actions.view }}</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          class="mr-2"
          :href="`whatsapp://send?phone=+55${customer.phone_nomask}`"
          target="_blank"
          :disabled="!(customer.phone_nomask > 0)"
        >
          <v-icon>mdi-whatsapp</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.actions.whatsapp }}</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          class="mr-2"
          :href="`tel:${customer.phone_nomask}`"
          target="_blank"
          :disabled="!(customer.phone_nomask > 0)"
        >
          <v-icon>mdi-phone-in-talk</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.actions.call }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.customers.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" small class="mr-2" @click="$emit('edit', customer)">
          <v-icon>mdi-account-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.customers.actions.delete">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" small class="mr-2" @click="deleteCustomer(customer)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import customers from '../mixins/index'

export default {
  mixins: [ appdata, customers ],
  props: {
    customer: Object,
    hideView: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>
